var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        {
          staticClass:
            "fixed top-18 z-40 w-88 flex-shrink-0 border-r border-slate-400 bg-pure-white"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "py-6 px-6 border-b border-slate-400 flex flex-col gap-3"
            },
            [
              _c(
                "div",
                [
                  _c("BlTextTitle3", { attrs: { text: "My Sessions" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1" },
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text: "These are the sessions assigned to you."
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "py-1 px-1 flex bg-slate-400",
                  style: { borderRadius: "8px", height: "2.375rem" }
                },
                _vm._l(_vm.previewTypeOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass:
                        "h-full w-full flex items-center justify-center gap-1 rounded cursor-pointer transition-all duration-300",
                      class: [
                        _vm.previewTypeInput === opt.value
                          ? "bg-pure-white"
                          : "bg-slate-400"
                      ],
                      on: {
                        click: function($event) {
                          return _vm.onChangePreviewType(opt.value)
                        }
                      }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-4 h-4",
                        attrs: { icon: opt.icon, color: "slate-6" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", { attrs: { text: opt.label } })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("div", {
                staticClass: "w-full grid place-items-center",
                style: { height: "calc(100vh - 15.5rem)" }
              })
            : _c(
                "div",
                {
                  staticClass: "overflow-y-auto",
                  style: { height: "calc(100vh - 15.5rem)" }
                },
                [
                  _vm.previewTypeInput === "calendar"
                    ? _c("div", { attrs: { id: "calendar-section" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "border-b border-slate-400 flex justify-center relative"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "absolute z-10 flex items-center gap-1 bg-pure-white",
                                style: {
                                  right: "10px",
                                  top: "8px",
                                  height: "32px"
                                }
                              },
                              [
                                _c("BlInputButton", {
                                  staticClass: "px-2",
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    label: "Today"
                                  },
                                  on: {
                                    clicked: function($event) {
                                      _vm.onDayClick({ date: new Date() })
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  staticClass: "border-none",
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    icon: "chevron-left"
                                  },
                                  on: {
                                    clicked: function($event) {
                                      return _vm.onMoveCalendar(-1)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  staticClass: "border-none",
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    icon: "chevron-right"
                                  },
                                  on: {
                                    clicked: function($event) {
                                      return _vm.onMoveCalendar(1)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-calendar", {
                              ref: "calendar",
                              staticClass: "border-none custom-calendar",
                              attrs: {
                                "is-expanded": "",
                                "hide-header": "",
                                "title-position": "left",
                                attributes: _vm.attrs
                              },
                              on: { dayclick: _vm.onDayClick }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.previewTypeInput === "list"
                    ? _c(
                        "div",
                        {
                          staticClass: "py-5 px-6",
                          attrs: { id: "list-section" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-between mb-3"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "text-slate-600",
                                attrs: { text: "Filters" }
                              }),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                staticClass: "px-0",
                                attrs: {
                                  type: "plain",
                                  dense: "",
                                  label: "Clear all"
                                },
                                on: { clicked: _vm.onClearAll }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col gap-2" }, [
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: {
                                    icon: "user-square",
                                    color: "slate-6"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlSingleFilter", {
                                  staticClass: "w-68",
                                  attrs: {
                                    label: "Client",
                                    placeholder: "By client",
                                    search: "",
                                    searchPlaceholder: "Search by name",
                                    fetchProperty: {
                                      url:
                                        "/api/v1/clients?sort=alphabetical&status=active&query=",
                                      dataKey: "clients",
                                      countKey: "total_clients",
                                      optionKeys: { value: "id", label: "name" }
                                    }
                                  },
                                  on: { change: _vm.onFilterClient },
                                  model: {
                                    value: _vm.filterClient,
                                    callback: function($$v) {
                                      _vm.filterClient = $$v
                                    },
                                    expression: "filterClient"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: {
                                    icon: "calendar-blank",
                                    color: "slate-6"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlSingleFilterDate", {
                                  staticClass: "w-68",
                                  on: { change: _vm.onFilterDate },
                                  model: {
                                    value: _vm.filterDate,
                                    callback: function($$v) {
                                      _vm.filterDate = $$v
                                    },
                                    expression: "filterDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.enableBranch
                              ? _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "h-6 w-6",
                                      attrs: {
                                        icon: "location",
                                        color: "slate-6"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlSingleFilter", {
                                      staticClass: "w-68",
                                      attrs: {
                                        label: "Branch",
                                        placeholder: "By branch",
                                        search: "",
                                        searchPlaceholder: "Search by name",
                                        fetchProperty: {
                                          url:
                                            "/api/v1/branches?sort=name_asc&query=",
                                          dataKey: "branches",
                                          countKey: "total_count",
                                          optionKeys: {
                                            value: "id",
                                            label: "name",
                                            color: "color",
                                            backgroundColor: "background_color"
                                          }
                                        }
                                      },
                                      on: { change: _vm.onFilterBranch },
                                      model: {
                                        value: _vm.filterBranch,
                                        callback: function($$v) {
                                          _vm.filterBranch = $$v
                                        },
                                        expression: "filterBranch"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.enableAppointment
                              ? _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "h-6 w-6",
                                      attrs: { icon: "door", color: "slate-6" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlSingleFilter", {
                                      staticClass: "w-68",
                                      attrs: {
                                        label: "Room",
                                        placeholder: "By room",
                                        search: "",
                                        searchPlaceholder: "Search by name",
                                        fetchProperty: {
                                          url: "/api/v1/rooms?query=",
                                          dataKey: "rooms",
                                          countKey: "total_count",
                                          optionKeys: {
                                            value: "id",
                                            label: "name"
                                          }
                                        }
                                      },
                                      on: { change: _vm.onFilterRoom },
                                      model: {
                                        value: _vm.filterRoom,
                                        callback: function($$v) {
                                          _vm.filterRoom = $$v
                                        },
                                        expression: "filterRoom"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: { icon: "loading", color: "slate-6" }
                                }),
                                _vm._v(" "),
                                _c("BlSingleFilter", {
                                  staticClass: "w-68",
                                  attrs: {
                                    label: "Status",
                                    placeholder: "By status",
                                    options: _vm.filterStatusOptions
                                  },
                                  on: { change: _vm.onFilterStatus },
                                  model: {
                                    value: _vm.filterStatus,
                                    callback: function($$v) {
                                      _vm.filterStatus = $$v
                                    },
                                    expression: "filterStatus"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
        ]
      ),
      _vm._v(" "),
      _vm.previewTypeInput === "calendar"
        ? _c(
            "div",
            { staticClass: "pl-88" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-12 px-6 sticky top-18 z-30 bg-slate-300 border-b border-slate-400 flex items-center justify-between gap-4",
                  style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "sticky top-18 left-94" },
                    [_c("BlTextBody2", { attrs: { text: _vm.masterDate } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky top-18 right-6 flex items-center gap-2"
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("BlSelectBox", {
                            attrs: {
                              options: _vm.timeslotViewOptions,
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                _vm.timeslotView = $event
                              }
                            },
                            model: {
                              value: _vm.timeslotView,
                              callback: function($$v) {
                                _vm.timeslotView = $$v
                              },
                              expression: "timeslotView"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          dense: "",
                          label: "Jump to"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.jumpToOpened = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { type: "outlined", dense: "", label: "Today" },
                        on: {
                          clicked: function($event) {
                            _vm.onDayClick({ date: new Date() })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "rounded-full",
                        attrs: {
                          type: "outlined",
                          dense: "",
                          icon: "chevron-left"
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onNextClick(-1)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "rounded-full",
                        attrs: {
                          type: "outlined",
                          dense: "",
                          icon: "chevron-right"
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onNextClick(1)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("Timeslots", {
                attrs: {
                  isCompact: _vm.timeslotView === "compact",
                  selectedDate: _vm.date,
                  headers: _vm.timeslotHeaders,
                  loading: _vm.previewLoading
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.previewTypeInput === "list"
        ? _c("div", { staticClass: "pl-88 bg-slate-100" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-16 px-6 sticky top-18 z-20 bg-slate-300 border-b border-slate-400 flex items-center justify-between gap-4",
                style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
              },
              [
                _c(
                  "div",
                  { staticClass: "sticky top-18 left-94" },
                  [
                    _c("BlInputSearch", {
                      staticClass: "w-80",
                      attrs: { input: _vm.searchInput },
                      on: { changed: _vm.onInputSearch }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.previewLoading
                  ? _c(
                      "div",
                      { staticClass: "w-full h-92 grid place-items-center" },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.mySessions || !_vm.mySessions.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "h-92 grid flex-col place-content-center text-center"
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "px-4 font-semibold",
                          attrs: { text: "No appointments scheduled" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "px-4",
                          attrs: {
                            text:
                              "You don't have any appointments assigned to you right now. Enjoy the downtime!"
                          }
                        })
                      ],
                      1
                    )
                  : _c("MySessionsTable")
              ],
              1
            ),
            _vm._v(" "),
            _vm.totalMySessions > 25
              ? _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("BlInputPagination", {
                      staticClass: "sticky left-94 my-10",
                      style: {
                        minWidth: "calc(100vw - 22rem - 3rem - 0.5rem)"
                      },
                      attrs: {
                        page: _vm.page,
                        perPage: _vm.perPage,
                        total: _vm.totalMySessions
                      },
                      on: {
                        changed: _vm.changePage,
                        "changed-per-page": _vm.changePerPage
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.jumpToOpened
        ? _c("JumpToDateModal", {
            attrs: { currentDate: _vm.date, dimension: "daily" },
            on: {
              "close-modal": function($event) {
                _vm.jumpToOpened = false
              },
              submit: function($event) {
                return _vm.onDayClick({ date: $event })
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b50ee8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b50ee8f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySessions/MySessions.vue
// module id = null
// module chunks = 